import * as React from "react";
const IconServer4 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M60.3 49.7h-1.7v-2.6c0-2.5-2-4.5-4.5-4.5s-4.5 2-4.5 4.5v2.6h-1.7c-.6 0-1 .4-1 1v7.2c0 .6.4 1 1 1h12.4c.6 0 1-.4 1-1v-7.2c0-.6-.5-1-1-1m-8.7-2.6c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v2.6h-5.1v-2.6zm7.7 9.8H48.9v-5.2h10.4z" />
    <path d="M62 24.6V11.4c0-2.8-2.2-5-5-5H7c-2.8 0-5 2.2-5 5v13.2c0 1.6.8 3.1 2 4-1.2.9-2 2.4-2 4v13.2c0 2.8 2.2 5 5 5h35.3c.6 0 1-.4 1-1s-.4-1-1-1H7c-1.7 0-3-1.3-3-3V32.6c0-1.7 1.3-3 3-3h50c1.7 0 3 1.3 3 3v9.6c0 .6.4 1 1 1s1-.4 1-1v-9.6c0-1.6-.8-3.1-2-4 1.2-.9 2-2.3 2-4m-2 0c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V11.4c0-1.7 1.3-3 3-3h50c1.7 0 3 1.3 3 3z" />
    <path d="M15.6 16.8c-.6 0-1 .4-1 1v.2c0 .6.4 1 1 1s1-.4 1-1v-.2c0-.6-.5-1-1-1M50.8 16.9H44c-.6 0-1 .4-1 1s.4 1 1 1h6.7c.6 0 1-.4 1-1s-.4-1-.9-1M14.6 39v.2c0 .6.4 1 1 1s1-.4 1-1V39c0-.6-.4-1-1-1s-1 .4-1 1M51.8 39c0-.6-.4-1-1-1H44c-.6 0-1 .4-1 1s.4 1 1 1h6.7c.6 0 1.1-.5 1.1-1" />
  </svg>
);
export default IconServer4;
